var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    paddingTop: _vm.images.length
      ? '3px' // Badge is vertically in the center for 1 content row
      : '',
  })},[(_vm.images.length > 1)?_c('div',{staticClass:"has-many-count-round mt-1"},[_vm._v(" "+_vm._s(_vm.images.length)+" ")]):_vm._e(),_c('Images',{model:{value:(_vm.images),callback:function ($$v) {_vm.images=$$v},expression:"images"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }